import React from 'react'

export const MARK_BACKGROUND_COLOR = 'backgroundColor';

export function renderBackgroundColorLeaf({ children, leaf }) {

    if (leaf[MARK_BACKGROUND_COLOR]) {
        const styles = {
            'background-color': leaf[MARK_BACKGROUND_COLOR],
            fontSize: 'inherit'
        };
        return (
            <span style={styles}>
                {children}
            </span>
        );
    }

    return children
};

export const BackgroundColorPlugin = () => ({
  renderLeaf: renderBackgroundColorLeaf,
});
